import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

const USER_SETTING_BASE = "/settings/User/me/";

const fetchCurrentUserSettingsAPI = () => API.get(`${USER_SETTING_BASE}`);

const updateCurrentUserSettingsAPI = (data) =>
  API.put(`${USER_SETTING_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const currentUserSettingBaseService = createApplicationService({
  name: "currentUserSettings",
  apiFetchFn: fetchCurrentUserSettingsAPI,
  apiUpdateFn: updateCurrentUserSettingsAPI,
});

const currentUserSettingsReducer = currentUserSettingBaseService.reducer;
const getCurrentUserSettings = currentUserSettingBaseService.getData;
const useCurrentUserSettings = currentUserSettingBaseService.useData;
const updateCurrentUserSettings = currentUserSettingBaseService.updateData;

const getCurrentUserSetting = async (settingKey) => {
  const userSettings = await getCurrentUserSettings();
  return userSettings.find((s) => s.key === settingKey) ?? null;
};

export {
  currentUserSettingsReducer,
  getCurrentUserSettings,
  useCurrentUserSettings,
  updateCurrentUserSettings,
  getCurrentUserSetting,
};
